// import React from 'react';
// import * as Sentry from '@sentry/react';
/*
import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from 'react-router-dom';
*/

const sentryInit = () => {
    /*
    Sentry.init({
        dsn: process.env.SENTRY.DSN,
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        integrations: [
            Sentry.replayIntegration({
                workerUrl: '/assets/worker.min.js',
                maskAllText: false,
                blockAllMedia: false,
                maskAllInputs: true,
                networkDetailAllowUrls: ['https://staging2.buywholefoodsonline.co.uk/graphql', 'https://www.buywholefoodsonline.co.uk/graphql'],
            }),
            Sentry.reactRouterV7BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Session Replay
        replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        profilesSampleRate: 1.0,
    });
    */
};

const sentryCaptureException = errors => {
    // Sentry.captureException(String(errors));
};

const sentrySetUser = user => {
    // Sentry.setUser(user);
};

export {
    sentryInit,
    sentryCaptureException,
    sentrySetUser,
};
